import merge from 'lodash/merge';
import { APP_SETTINGS_VERSION_1 } from '../constants/versions';
import { defaultSettingsV0 } from './version-0';

/* Don't change settings here! To change settings behavior, create new version */

/* Starting from this version all settings are saved explicitly,
 giving us ability safely change defaults for new users */

export function migrateToV1(appSettingsV0) {
  return merge(
    {},
    defaultSettingsV0,
    appSettingsV0,
    {
      numbers: {
        settingsVersion: APP_SETTINGS_VERSION_1,
      },
    },
  );
}



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/migrations/version-1.js